import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import App from "../src/containers/App/App";
import ErrorBoundaryFallback from "./sentry/ErrorBoundaryFallback";
import { scrubEvent } from "./sentry/eventScrubber";
import installDeferredResizeObserver from "./shared/deferResizeObserverCallbacks";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

// Must be called here in the body — not imported for its side effects — so it
// only reaches observers constructed at mount. See the ordering constraint in
// `~/.claude-specs/incentco/ICOV3-1660-specs.md`.
installDeferredResizeObserver();

// Sentry init must run before the first render so boot-time errors get
// captured. Empty DSN in local dev makes the SDK a no-op.
// See `~/.claude-specs/incentco/ICOV3/ICOV3-1386-specs.md`.
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || undefined,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "local",
  sendDefaultPii: false,
  beforeSend: scrubEvent,
  ignoreErrors: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ],
});

ReactDOM.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
